import axios from "axios";

let loggingOut = false;

// Shared by the axios interceptor below and the Apollo error link in
// config.js, so any 401 from either transport lands here instead of
// leaving the user stuck on a screen full of "unable to load" errors.
export const forceLogout = () => {
  if (loggingOut || window.location.pathname === "/login") return;
  loggingOut = true;

  // Save logo keys BEFORE clearing auth — they must survive logout/login.
  const logoKeysToKeep = ["uploadedLogoDataUrl", "filePath"];
  const preserved = {};
  logoKeysToKeep.forEach((k) => {
    const v = localStorage.getItem(k);
    if (v && v !== "null" && v !== "undefined") preserved[k] = v;
  });

  [
    "token",
    "tokenExpiration",
    "decodedToken",
    "rights",
    "rightsforrbac",
    "systemAToken",
    "pendingAuth",
  ].forEach((k) => localStorage.removeItem(k));

  // Restore logo keys.
  Object.entries(preserved).forEach(([k, v]) => localStorage.setItem(k, v));

  window.location.href = "/login";
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      forceLogout();
    }
    return Promise.reject(error);
  },
);
